import React, { useEffect, useRef, useState } from "react";

export default function CountUp({ value = 0, duration = 1200, prefix = "", suffix = "", className = "" }) {
  const [display, setDisplay] = useState(value);
  const fromRef = useRef(value);

  useEffect(() => {
    const from = fromRef.current;
    const to = value;
    if (from === to) { setDisplay(to); return; }
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const current = from + (to - from) * eased;
      setDisplay(current);
      if (t < 1) raf = requestAnimationFrame(tick);
      else fromRef.current = to;
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);

  const rounded = Number.isInteger(value) ? Math.round(display) : Math.round(display * 10) / 10;
  return <span className={className}>{prefix}{rounded.toLocaleString("es-AR")}{suffix}</span>;
}
